// src/db/accessDB.ts
import Dexie, { Table } from 'dexie';

export interface AccessEntry {
  id?: number;
  canAccess: boolean;
}

class AccessDatabase extends Dexie {
  access!: Table<AccessEntry, number>;

  constructor() {
    super('AccessDatabase');
    this.version(1).stores({
      access: '++id'
    });
  }
}

export const accessDB = new AccessDatabase();
